import dayjs from 'dayjs';

const addMonths = (date: Date | string, months: number): string =>
  dayjs(date).add(months, 'month').toISOString();

export { addMonths };
